// src/components/dashboard/CreditsCard.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import { WEBSITE_MEMBERSHIPS } from '../../utils/raceNightFormat';

/**
 * The non-member's card on the home (board HomeV2NonMember): the credits balance, Buy credits, the
 * same ONE Book a session button a member has, and a quiet line about memberships.
 */
const CreditsCard: React.FC<{ balance: number | null }> = ({ balance }) => (
  <div className="entitlement-card">
    <div className="ent-stripe" aria-hidden="true" />
    <div className="ent-body">
      <span className="ent-badge">Credits</span>
      <div className="ent-balance">
        <span className="ent-balance-value">{balance ?? '—'}</span>
        <span className="ent-balance-unit">credits</span>
      </div>
      <Link to="/checkout" className="ent-link ent-buy">Buy credits ›</Link>
      <Link to="/book" className="ent-cta">Book a session</Link>
      <p className="ent-members-line">
        Members get included sessions and race nights.{' '}
        <a className="ent-link" href={WEBSITE_MEMBERSHIPS} target="_blank" rel="noreferrer">See memberships ›</a>
      </p>
    </div>
  </div>
);

export default CreditsCard;
